import { MeRepository } from 'common/repositories/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$state'];

let _$state;
let rid;
class LanguageSwitcherController {

    constructor($state) {

        const userLanguage = MeRepository.getMyUser().attributes.language;

        // translate en -> English from config file
        this.Language = CWCONFIG.languages[userLanguage] || userLanguage;
        _$state = $state;

    }

    openModal(modal) {

        if (!_$state.params.resourceId) {

            rid = 'all';
            _$state.go(`${_$state.current.name}.ltb`, {
                ltb: modal,
                resourceId: rid,
            });

        } else {

            _$state.go(`${_$state.current.name}.ltb`, {
                ltb: modal,
            });

        }

    }

}

class LanguageSwitcherDirective {

    constructor() {

        this.template = require('./language-switcher.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push($state => new LanguageSwitcherController($state));
        this.controller = _controllerDependencies;
        this.controllerAs = 'languageSwitcherCtrl';

    }

}

_directiveDependencies.push(() => new LanguageSwitcherDirective());

angular.module('directives').directive('languageSwitcher', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/language-switcher/language-switcher.js